/** The chat composer's box: a glass pill at shell radius. Shared by anything that takes a reply. */
export const COMPOSER_SURFACE =
  "rounded-shell glass-field shadow-panel transition-colors focus-within:border-input";

/** The composer's round send button. */
export const COMPOSER_SEND_BUTTON = "size-9 shrink-0 disabled:opacity-50 disabled:shadow-none";
